import React, {useState } from 'react';

import { Icon } from '../IconExporter'
import { Container } from './styles';

export type DropZoneProps = {
  error?: boolean;
}

export const DropZone = ({error = false}: DropZoneProps) => {
  const [isHovering, setIsHovering] = useState(false);

  if (error) {
    return <Container hasError={error}>
      <div>
        <p>incompatível</p>
        <Icon name="prohibited" size={14} />
      </div>
    </Container>
  }

  return <Container 
    onMouseEnter={() => setIsHovering(true)} 
    onMouseLeave={() => setIsHovering(false)} 
    hasError={error}
    >
    {isHovering  ? 
      <div>
        <p>solte aqui</p>
        <Icon name="mover" size={14} />
      </div>
      :
      <div>
        <p>arraste aqui</p>
        <Icon name="mover" size={14} />
      </div>
    }
  </Container>;
}